import type { z } from "zod";

type ZodIssue = z.core.$ZodIssue;

export interface EnrichedZodIssue {
  code: string;
  path: PropertyKey[];
  message: string;
  received: unknown;
  input: unknown;
  [key: string]: unknown;
}

/**
 * Walks a Zod issue's `path` through the source data to extract the
 * actual value that failed validation (Zod v4 omits this from output).
 */
function getValueAtPath(data: unknown, path: PropertyKey[]): unknown {
  let current: unknown = data;
  for (const segment of path) {
    if (current == null || typeof current !== "object") {
      return undefined;
    }
    current = (current as Record<PropertyKey, unknown>)[segment];
  }
  return current;
}

/**
 * Returns a copy of each Zod issue enriched with:
 * - `received`: the actual leaf value that failed validation
 * - `input`: the parent object containing the failing field
 */
export function enrichZodIssues(
  issues: ZodIssue[],
  source: unknown,
): EnrichedZodIssue[] {
  return issues.map((issue) => ({
    ...issue,
    received: getValueAtPath(source, issue.path),
    input: issue.path.length > 0
      ? getValueAtPath(source, issue.path.slice(0, -1))
      : source,
  }));
}
